module.exports = __webpack_public_path__ + "img/mobile/SmartButton-promo/btn-spin@1x.png?0.0.53";